import React from 'react'
import { useTranslation } from 'react-i18next'

import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import SendIcon from '@mui/icons-material/Send'

import colors from '@/assets/scss/_themes-vars.module.scss'

import { ChatItem } from '@/components/ui/chat/Chat'
import ChatBox from '@/components/ui/chat/ChatBox'
import ChatFeed from '@/components/ui/chat/ChatFeed'
import ChatInput from '@/components/ui/chat/ChatInput'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'

export type MessengerProps = {
  chatRoomId?: string
  dataSource: ChatItem[]
  onClose?: () => void
  onSendMessage: (message: string) => void
  open: boolean
  url?: string
}

export function Messenger(props: MessengerProps) {
  const { dataSource, onClose, onSendMessage, open, url } = props
  const { t } = useTranslation()
  const isTooSmall = useIsMobile()

  const handleClose = () => {
    onClose?.()
  }

  const handleSendMessage = (message: string) => {
    onSendMessage(message)
  }

  return !open ? null : (
    <Paper
      sx={{
        borderRadius: '6px 6px 0 0',
        position: 'fixed',
        bottom: 0,
        right: isTooSmall ? 0 : '80px',
        width: isTooSmall ? '100%' : '350px',
        height: isTooSmall ? '90%' : '450px',
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
    >
      <Stack sx={{ height: '100%', width: '100%' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            padding: '5px 5px 5px 10px',
          }}
        >
          <Typography variant="h2" component="p" sx={{ color: colors.gray500, fontSize: '14px', fontWeight: 500 }}>
            {t('page.liveConsultation.messenger.title')}
          </Typography>
          <Tooltip title={t('common:button.close.tooltip')} placement="top">
            <IconButton onClick={handleClose} size="small">
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
        <Divider />
        {!url ? (
          <>
            <ChatFeed>
              {dataSource.map((dataItem, index) => (
                <ChatBox key={`${dataItem.date} - ${index}`} {...dataItem} />
              ))}
            </ChatFeed>
            <Divider />
            <ChatInput
              onSendMessage={handleSendMessage}
              sendIcon={
                <IconButton>
                  <SendIcon />
                </IconButton>
              }
              sx={{
                p: '5px',
              }}
            />
          </>
        ) : (
          <iframe title="rocket-chat-messenger" src={url} style={{ width: '100%', height: '100%', border: 'none' }}></iframe>
        )}
      </Stack>
    </Paper>
  )
}

export default Messenger
